// extracted by mini-css-extract-plugin
export default {"root":"gEeWzR","appear":"Sb_CSN"};